/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {CageTemperatureForecast} from '../bioplanModels';
/**
 * PlanningCageForecastApi - axios parameter creator
 * @export
 */
export const PlanningCageForecastApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Cage forecast
     * @param {Array<string>} cageId
     * @param {CageForecastGetMetricEnum} metric
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cageForecastGet: async (
      cageId: Array<string>,
      metric: CageForecastGetMetricEnum,
      startDate: string,
      endDate: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'cageId' is not null or undefined
      assertParamExists('cageForecastGet', 'cageId', cageId);
      // verify required parameter 'metric' is not null or undefined
      assertParamExists('cageForecastGet', 'metric', metric);
      // verify required parameter 'startDate' is not null or undefined
      assertParamExists('cageForecastGet', 'startDate', startDate);
      // verify required parameter 'endDate' is not null or undefined
      assertParamExists('cageForecastGet', 'endDate', endDate);
      const localVarPath = `/cageForecast`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (metric !== undefined) {
        localVarQueryParameter['metric'] = metric;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningCageForecastApi - functional programming interface
 * @export
 */
export const PlanningCageForecastApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningCageForecastApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Cage forecast
     * @param {Array<string>} cageId
     * @param {CageForecastGetMetricEnum} metric
     * @param {string} startDate
     * @param {string} endDate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cageForecastGet(
      cageId: Array<string>,
      metric: CageForecastGetMetricEnum,
      startDate: string,
      endDate: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CageTemperatureForecast>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cageForecastGet(
        cageId,
        metric,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCageForecastApi.cageForecastGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningCageForecastApi - factory interface
 * @export
 */
export const PlanningCageForecastApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningCageForecastApiFp(configuration);
  return {
    /**
     *
     * @summary Cage forecast
     * @param {PlanningCageForecastApiCageForecastGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cageForecastGet(
      requestParameters: PlanningCageForecastApiCageForecastGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CageTemperatureForecast> {
      return localVarFp
        .cageForecastGet(
          requestParameters.cageId,
          requestParameters.metric,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for cageForecastGet operation in PlanningCageForecastApi.
 * @export
 * @interface PlanningCageForecastApiCageForecastGetRequest
 */
export interface PlanningCageForecastApiCageForecastGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PlanningCageForecastApiCageForecastGet
   */
  readonly cageId: Array<string>;

  /**
   *
   * @type {'temperature'}
   * @memberof PlanningCageForecastApiCageForecastGet
   */
  readonly metric: CageForecastGetMetricEnum;

  /**
   *
   * @type {string}
   * @memberof PlanningCageForecastApiCageForecastGet
   */
  readonly startDate: string;

  /**
   *
   * @type {string}
   * @memberof PlanningCageForecastApiCageForecastGet
   */
  readonly endDate: string;
}

/**
 * PlanningCageForecastApi - object-oriented interface
 * @export
 * @class PlanningCageForecastApi
 * @extends {BaseAPI}
 */
export class PlanningCageForecastApi extends BaseAPI {
  /**
   *
   * @summary Cage forecast
   * @param {PlanningCageForecastApiCageForecastGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCageForecastApi
   */
  public cageForecastGet(
    requestParameters: PlanningCageForecastApiCageForecastGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCageForecastApiFp(this.configuration)
      .cageForecastGet(
        requestParameters.cageId,
        requestParameters.metric,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const CageForecastGetMetricEnum = {
  Temperature: 'temperature',
} as const;
export type CageForecastGetMetricEnum = (typeof CageForecastGetMetricEnum)[keyof typeof CageForecastGetMetricEnum];
